import { ReactElement } from 'react';

export const validTabIds = [
  'cursos',
  'semestres',
  'kolb-agrupamento',
  'gestor',
  'coordenador',
  'assistente',
  'auxiliar',
  'professor',
  'preceptor',
  'nomenclaturas',
  'visao-geral',
  'dados-cadastrais',
  'configuracoes',
  'advertising',
  'equipe',
  'tce',
  'avaliacao-campo',
] as const;

export type EntitySettingsTabIds = (typeof validTabIds)[number];

export interface IEntitySettingsTab {
  id: EntitySettingsTabIds;
  label: string;
  icon?: ReactElement;
  nameFeatherIcon?: string;
  classNameColorIcon?: string;
  tabContent: ReactElement;
}
